import type { ApiBlock } from './block'

/**
 * Values accepted by the `pageName` path param of the Content API
 * `/content/page-sections/...` endpoints.
 *
 * Mirrors `PageSectionType` in the Content API. These values are NOT always
 * equal to the front-office route names (e.g. the `trade_in_product` route
 * uses `buyback-model-page`).
 *
 * @see {@link https://github.com/BackMarket/content/blob/main/content/domain/page_sections/entities.py}
 */
export const CMS_PAGE_SECTION_NAMES = {
  MASTER_PP: 'master-pp',
  PRODUCT: 'product',
  LANDING_PAGE: 'landing_page',
  BUYBACK_MODEL_PAGE: 'buyback-model-page',
} as const

export type CMSPageSectionName =
  (typeof CMS_PAGE_SECTION_NAMES)[keyof typeof CMS_PAGE_SECTION_NAMES]

export const sectionBlockKeys = [
  'section1',
  'section2',
  'section3',
  'section4',
  'section5',
] as const

type SectionBlockKey = (typeof sectionBlockKeys)[number]

export type CMSSectionsAPI = {
  id: string
  technicalName: string | null
} & Record<SectionBlockKey, ApiBlock[]>
